import { Modal_Content_default } from "./chunk-AON572BS.js";
import { Modal_Footer_default } from "./chunk-TZLAHJU4.js";
import { Modal_default } from "./chunk-GEG5VV5N.js";
import { Modal_Header_default } from "./chunk-HROTFANZ.js";

// src/components/Modal/index.ts
var ModalComponent = Modal_default;
ModalComponent.Header = Modal_Header_default;
ModalComponent.Header.displayName = "Modal.Header";
ModalComponent.Content = Modal_Content_default;
ModalComponent.Content.displayName = "Modal.Content";
ModalComponent.Footer = Modal_Footer_default;
ModalComponent.Footer.displayName = "Modal.Footer";
export { ModalComponent };